<template>
  <div>
    <h4
      class="font-weight-bolder"
      :class="titleClass"
    >
      {{ titleText }}
    </h4>
  </div>
</template>
<script>
export default {
  name: 'PrimaryHeading',
  props: {
    titleText: {
      type: String,
      default: null,
    },
    titleClass: {
      type: String,
      default: 'text-primary',
    },
  },
}
</script>
